import { render, staticRenderFns } from "./feedbackDialog.vue?vue&type=template&id=54decf35&scoped=true"
import script from "./feedbackDialog.vue?vue&type=script&lang=js"
export * from "./feedbackDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54decf35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54decf35')) {
      api.createRecord('54decf35', component.options)
    } else {
      api.reload('54decf35', component.options)
    }
    module.hot.accept("./feedbackDialog.vue?vue&type=template&id=54decf35&scoped=true", function () {
      api.rerender('54decf35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/downLoadCenter/feedbackDialog.vue"
export default component.exports